import { ThemedButton, type ThemedButtonProps } from "./ThemedButton";

/**
 * A themed button with the secondary variant, which is a gray button.
 *
 * @example <ThemedButton variant="secondary">
 *
 **/
export const SecondaryButton = (props: ThemedButtonProps) => (
  <ThemedButton fullWidth variant="secondary" {...props} /> // yes new theme says old secondary is now primary
);
